<template>
  <div :class="cn('rounded-none border bg-card text-card-foreground shadow-sm', $attrs.class)">
    <div v-if="$slots.header" class="flex flex-col space-y-1.5 p-4">
      <slot name="header" />
    </div>
    <div :class="cn('p-4 pt-0', !$slots.header && 'pt-4')">
      <slot />
    </div>
    <div v-if="$slots.footer" class="flex items-center p-4 pt-0">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
import { cn } from "@/lib/utils";

export default {
  name: "UiCard",
  setup() {
    return { cn };
  },
};
</script>
